<template>
    <div class="flex flex-col sm:flex-row justify-between sm:items-center pt-8 gap-2">
        <div class="order-1 sm:order-0">

            <RestaurantsListSearch />

        </div>

        <div class="h6 tracking-wide">{{ searchedRestaurants.length }} {{activeFilterName}} restaurants<template v-if="isSearching"> nearby</template></div>
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useRestaurantsListStore } from '../../stores/restaurant-list-store';
import RestaurantsListSearch from './RestaurantsListSearch.vue';


const store = useRestaurantsListStore();

const { activeFilterName, searchedRestaurants, isSearching } = storeToRefs(store);
</script>
